import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse, UserRequestDto } from '@gtpl/shared-models/common-models';
import { AllHlPercentageResponseModel, HlPercentageRequest, HlPercentageResponseModel } from '@gtpl/shared-models/masters';
import { HlPercentageAdapter } from './dto/hl-percentage.adapter';
import { HlPercentageDTO } from './dto/hl-percentage.dto';
import { HlPercentage } from './hl-percentage.entity';
import { HlPercentageRangeRequest } from './dto/hl-percentage-range.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class HlPercentagesService {
    constructor(
      private logService:LogsService,
        @InjectRepository(HlPercentage)
        private hlPercentageRepository: Repository<HlPercentage>,
        private hlPercentageAdapter: HlPercentageAdapter,
    ){}

    /**
     * get hlPercentage details
     * @param hlPercentage 
     */
    // @LogActions({isAsync: true})
    async getHlPercentageDetailsWithoutRelations(minGrade: number, maxGrade:number): Promise<HlPercentage> {
        // tslint:disable-next-line: typedef
        const hlPercentageResponse = await this.hlPercentageRepository.findOne({
          where: {minGrade: Raw(alias => `min_grade = '${minGrade}'`), maxGrade: Raw(alias => `max_grade = '${maxGrade}'`)},
        });
        if (hlPercentageResponse) {
          return hlPercentageResponse;
        } else {
          return null;
        }
      }

      async createHlPercentage(hlPercentageDto: HlPercentageDTO, isUpdate: boolean): Promise<HlPercentageResponseModel> {
        // console.log(statesDto);
        try {
          let previousValue
          // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
          if (!isUpdate) {
            const hlPercentageEntity = await this.getHlPercentageDetailsWithoutRelations(hlPercentageDto.minGrade, hlPercentageDto.maxGrade);
            if (hlPercentageEntity) {
              //return new InformationMessageError(11104, "State already exists");
              throw new ErrorResponse(11104, 'HlPercentage already exists');
            }
          }else{
            const certificatePrevious = await this.hlPercentageRepository.findOne({where:{hlPercentageId:hlPercentageDto.hlPercentageId}})
            previousValue = certificatePrevious.minGrade+','+certificatePrevious.maxGrade+','+certificatePrevious.hlPercentage
            const hlPercentageEntity = await this.getHlPercentageDetailsWithoutRelations(hlPercentageDto.minGrade, hlPercentageDto.maxGrade);
            if (hlPercentageEntity) {
                if(hlPercentageEntity.hlPercentageId!=hlPercentageEntity.hlPercentageId){
                  throw new ErrorResponse(11104, 'HlPercentage already exists unable to update');
                }
            }
          }
          const convertedHlPercentageEntity: HlPercentage = this.hlPercentageAdapter.convertDtoToEntity(hlPercentageDto,isUpdate);
          const savedHlPercentageEntity: HlPercentage = await this.hlPercentageRepository.save(
            convertedHlPercentageEntity
          );
          const savedHlPercentageDto: HlPercentageDTO = this.hlPercentageAdapter.convertEntityToDto(convertedHlPercentageEntity);
            // console.log(savedStateDto);
          if (savedHlPercentageDto) {
            const present = savedHlPercentageDto.minGrade+','+savedHlPercentageDto.maxGrade+','+savedHlPercentageDto.hlPercentage
            // generating resposnse
            const response = new HlPercentageResponseModel(true,1,isUpdate? 'HlPercentage Updated Successfully': 'HlPercentage Created Successfully')
            const name=isUpdate?'updated':'created'
            const display = isUpdate?'HlPercentage Updated Successfully': 'HlPercentage Created Successfully'
            const userName= isUpdate?savedHlPercentageDto.updatedUser:savedHlPercentageDto.createdUser
            const newLogDto = new LogsDto(1,name, 'HlPercentage', savedHlPercentageDto.hlPercentageId, true, display,userName,previousValue,present)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response
          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new ErrorResponse(11106,'HlPercentage saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          throw error;
        }
      }  

      async getAllHlPercentage(req?:UserRequestDto): Promise<AllHlPercentageResponseModel> {
        // const page: number = 1;
        
        try {
          const HlPercentageDtos: HlPercentageDTO[] = [];
          //retrieves all companies
          const HlPercentageEntities: HlPercentage[] = await this.hlPercentageRepository.find({order :{'hlPercentageId':'ASC'}});
          //console.log(statesEntities);
          if (HlPercentageEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            HlPercentageEntities.forEach(HlPercentageEntity => {
              const convertedHlPercentageDto: HlPercentageDTO = this.hlPercentageAdapter.convertEntityToDto(
                HlPercentageEntity
              );
              HlPercentageDtos.push(convertedHlPercentageDto);
            });
            const response = new AllHlPercentageResponseModel(true,1,'Hl Percentage retrieved successfully',HlPercentageDtos);
            //generated response
            if (req?.createdUser){
              const newLogDto = new LogsDto(1,'view', 'HlPercentage', 0, true, 'Hl Percentage retrieved successfully',req.createdUser)
              let res = await this.logService.createLog(newLogDto);
              console.log(res);
            }
            return response
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        
        } catch (err) {
          throw err;
        }
      }
      async getAllActiveHlPercentage(): Promise<AllHlPercentageResponseModel> {
        // const page: number = 1;
        try {
            const hlPercentageDto: HlPercentageDTO[] = [];
            //retrieves all companies
            const HlPercentageEntities: HlPercentage[] = await this.hlPercentageRepository.find({ order: { 'hlPercentage': 'ASC' },where:{isActive:true},
           });
         console.log(HlPercentageEntities)
            if (HlPercentageEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                HlPercentageEntities.forEach(hlPercentageEntity => {
                    const convertedhlPercentageDto: HlPercentageDTO = this.hlPercentageAdapter.convertEntityToDto(
                      hlPercentageEntity
                      
                    );
                    hlPercentageDto.push(convertedhlPercentageDto);
                });
                const response = new AllHlPercentageResponseModel(true, 11108, "HlPercentage retrieved successfully", hlPercentageDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found'); hlPercentageDto
            }
        } catch (err) {
            throw err;
        }
    }
      async activateOrDeactivateHlPercentage(hlPercentageReq: HlPercentageRequest): Promise<HlPercentageResponseModel> {
        try {
            const hlPercentageExists = await this.getHlPercentageById(hlPercentageReq.hlPercentageId);
            if (hlPercentageExists) {
                if (hlPercentageReq.versionFlag !== hlPercentageExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current hlPercentage information.Refresh and try again');
                } else {
                    
                        const hlPercentageStatus =  await this.hlPercentageRepository.update(
                            { hlPercentageId: hlPercentageReq.hlPercentageId },
                            { isActive: hlPercentageReq.isActive,updatedUser: hlPercentageReq.updatedUser });
                       
                        if (hlPercentageExists.isActive) {
                            if (hlPercentageStatus.affected) {
                                const hlPercentageResponse: HlPercentageResponseModel = new HlPercentageResponseModel(true, 10115, 'HlPercentage is de-activated successfully');
                                return hlPercentageResponse;
                            } else {
                                throw new ErrorResponse(10111, 'HlPercentage is already deactivated');
                            }
                        } else {
                            if (hlPercentageStatus.affected) {
                                const HlPercentageResponse: HlPercentageResponseModel = new HlPercentageResponseModel(true, 10114, 'HlPercentage is activated successfully');
                                return HlPercentageResponse;
                            } else {
                                throw new ErrorResponse(10112, 'HlPercentage is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
      async getActiveHlPercentageById(hlPercentageReq: HlPercentageRequest): Promise<HlPercentageResponseModel> {
        try {
          //retrieves all companies
          const HlPercentageEntities: HlPercentage = await this.hlPercentageRepository.findOne({
              where:{hlPercentageId:hlPercentageReq.hlPercentageId}
              });
              
              const hlPercentageData: HlPercentageDTO = this.hlPercentageAdapter.convertEntityToDto(HlPercentageEntities);
              if (hlPercentageData) {
                  const response = new HlPercentageResponseModel(true, 11101 , 'HlPercentage retrived Successfully',hlPercentageData);
                  return response;
              }
              else{
                  throw new ErrorResponse(11106,'Something went wrong');
              }
              // generating resposnse
      } catch (err) {
          throw err;
      }
    }

     async getHlPercentageByRange(hlPerReq: HlPercentageRangeRequest): Promise<HlPercentageResponseModel> {
      try {
        //retrieves all companies
        const HlPercentageEntities: HlPercentage[] = await this.hlPercentageRepository.find();
        
        for(const HlPercentageItem of HlPercentageEntities){
          if(hlPerReq.Grade >= HlPercentageItem.minGrade && hlPerReq.Grade <= HlPercentageItem.maxGrade){
             
            const hlPercentageData: HlPercentageDTO = this.hlPercentageAdapter.convertEntityToDto(HlPercentageItem);
            if (hlPercentageData) {
                const response = new HlPercentageResponseModel(true, 11101 , 'HlPercentage retrived Successfully',hlPercentageData);
                return response;
            }
            else{
                return  new HlPercentageResponseModel(false, 9999 , 'No range defined with given Grade',undefined);
            }
          }
          }
            
            // generating resposnse
    } catch (err) {
        throw err;
    }
  }

    async getHlPercentageById(hlPercentageId: number): Promise<HlPercentage> {
        //  console.log(employeeId);
            const Response = await this.hlPercentageRepository.findOne({
            where: {hlPercentageId: hlPercentageId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }
}

